import api from "./api";

export interface AnexoEdital {
  id: number;
  filename: string;
  content_type: string;
  byte_size: number;
  url: string;
  created_at: string;
}

export interface EditalPublico {
  id: number;
  nome: string;
  descricao: string;
  data_inicio: string;
  data_fim: string;
  edital_pdf_url?: string; // Mantém compatibilidade
  anexos?: AnexoEdital[]; // Nova lista de anexos
  dias_restantes?: number;
  status_periodo?: "em_breve" | "aberto" | "encerrado";
  dias_para_inicio?: number;
  formacao_minima_requerida?: string;
  pode_inscrever?: boolean;
  motivo_nao_pode_inscrever?: string;
  elegivel?: boolean; // Elegibilidade baseada apenas em requisitos
  motivo_inelegibilidade?: string; // Motivo da inelegibilidade por requisitos
}

export interface EditalPublicoDetalhado extends EditalPublico {
  configuracoes?: Record<string, unknown>;
  schema_campos: Record<
    string,
    {
      type: string;
      label: string;
      required?: boolean;
      placeholder?: string;
      maxLength?: number;
      min?: number;
      max?: number;
      default?: string | number;
      options?: string[];
    }
  >;
  ja_inscrito?: boolean; // Se o proponente já fez inscrição neste edital
}

const editaisPublicosService = {
  // Listar editais publicados
  listar: async (params?: {
    busca?: string;
  }): Promise<{ editais: EditalPublico[] }> => {
    const response = await api.get("/api/v1/editais", { params });
    return response.data;
  },

  // Buscar edital público
  buscar: async (id: number): Promise<{ edital: EditalPublicoDetalhado }> => {
    const response = await api.get(`/api/v1/editais/${id}`);
    return response.data;
  },

  // Obter formulário do edital
  obterFormulario: async (
    id: number
  ): Promise<{
    edital: {
      id: number;
      nome: string;
      descricao: string;
      data_fim: string;
    };
    schema_campos: Record<string, {
      type: string;
      label: string;
      required?: boolean;
      placeholder?: string;
      maxLength?: number;
      min?: number;
      max?: number;
      default?: string | number;
      options?: string[];
    }>;
    configuracoes?: Record<string, unknown>;
  }> => {
    const response = await api.get(`/api/v1/editais/${id}/formulario`);
    return response.data;
  },

  // Verificar elegibilidade
  verificarElegibilidade: async (
    id: number
  ): Promise<{
    elegivel: boolean;
    mensagem?: string;
    motivo?: string;
    ja_inscrito?: boolean;
  }> => {
    const response = await api.get(
      `/api/v1/editais/${id}/verificar_elegibilidade`
    );
    return response.data;
  },
};

export default editaisPublicosService;
